export enum ValidationStatus {
    VALID = 'VALID',
    REVISE = 'REVISE',
    REJECT = 'REJECT',
}
